import { render, staticRenderFns } from "./NewUiNotifications.vue?vue&type=template&id=7357f95c&"
import script from "./NewUiNotifications.vue?vue&type=script&lang=ts&"
export * from "./NewUiNotifications.vue?vue&type=script&lang=ts&"
import style0 from "./NewUiNotifications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports